<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2025-02-13 17:28:00
 * @FilePath: /wemeet-admin-new/src/views/marketing/components/addPointsType.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer userInfoDrawer"
    :direction="direction"
    :size="size"
    title="分类管理"
  >
    <vab-query-form>
      <vab-query-form-left-panel :span="12" />
      <vab-query-form-right-panel :span="12">
        <el-form inline>
          <el-form-item>
            <el-button type="primary" @click="addType()">添加分类</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>

    <div class="containerForm">
      <el-table :data="list">
        <el-table-column label="活动类型名称" prop="typeName" />
        <el-table-column label="备注" prop="remark" />
        <el-table-column label="每日活动积分获取上限" prop="pointsLimit" />
        <el-table-column label="操作">
          <template #default="{ row }">
            <el-button type="primary" @click="addType(row)">编辑</el-button>
            <el-button type="danger" @click="delHostInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.pageNum"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-drawer ref="drawerRef" v-model="dialogFormVisible1" :append-to-body="true" :size="size1" :title="title">
      <el-form ref="reasonRef" :model="form" :rules="rules">
        <el-form-item label="活动类型名称" prop="typeName">
          <el-input v-model="form.typeName" type="text" />
        </el-form-item>
        <el-form-item label="每日活动积分获取上限" prop="pointsLimit">
          <el-input-number v-model="form.pointsLimit" :min="0" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" type="text" />
        </el-form-item>
        <el-form-item align="center">
          <el-button size="large" type="primary" @click="save">提交</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>

    <!-- <div class="demo-drawer__footer">

    </div> -->
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { getActivityTypeList, addActivityType, updateActivityType, transferTeamwork } from '@/api/exhibitionManage'
  import { getUserByPhone } from '@/api/user'
  export default defineComponent({
    name: 'UserDetail',
    props: {
      meetingCode: {
        type: String,
        default: '',
      },
      meetingType: {
        type: String,
        default: 'HOLD_MEETING',
      },
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: '50%',
        dialogFormVisible1: false,
        size1: '30%',
        rules: {
          typeName: [{ required: true, message: '请输入活动类型名称', trigger: 'blur' }],
          // pointsLimit: [
          //   {
          //     required: true,
          //     message: '请输入每日活动积分获取上限',
          //     trigger: 'blur',
          //   },
          // ],
        },

        layout: 'total, sizes, prev, pager, next, jumper',
        form: {
          pointsLimit: 0,
        },
        list: [],
        phone: '',
        title: '添加分类',
        options: [
          {
            value: 'FORM',
            label: '表单',
          },
          {
            value: 'NO_SIGN_UP',
            label: '无报名',
          },
        ],
        queryForm: {
          meetingCode: '',
          pageNum: 1,
          pageSize: 10,
        },
        editType: 'add',
        reasonRef: null,
        total: 0,
      })
      // 打开
      const handleOpen = async (row) => {
        state.row = row
        state.dialogFormVisible = true
        queryData()
      }
      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
        state.form = {
          pointsLimit: 0,
          typeName: '',
          remark: '',
        }
      }

      const queryData = async () => {
        state.queryForm.meetingCode = props.meetingCode
        const { data } = await getActivityTypeList(state.queryForm)
        console.log(data)
        state.total = data.total
        state.list = data.list
      }

      const save = async () => {
        state['reasonRef'].validate(async (valid) => {
          if (valid) {
            try {
              state.form.meetingCode = props.meetingCode
              if (state.editType === 'edit') {
                const { data } = await updateActivityType(state.form)
                proxy.$baseMessage(`更新成功`, 'success', 'vab-hey-message-success')
              } else {
                const { data } = await addActivityType(state.form)
                proxy.$baseMessage(`新增成功`, 'success', 'vab-hey-message-success')
              }

              // handleClose()
              state.dialogFormVisible1 = false
              state.form = {
                pointsLimit: 0,
                typeName: '',
                remark: '',
              }
              queryData()
            } catch (e) {}
          }
        })
      }

      const addType = async (row) => {
        if (row) {
          state.title = `编辑分类`
          state.editType = `edit`
          state.form = Object.assign(state.form, row)
        } else {
          state.editType = `add`
          state.title = `添加分类`
        }
        state.dialogFormVisible1 = true
      }

      const delHostInfo = async (row) => {
        try {
          proxy.$baseConfirm('确定删除该分类吗？', '提示', async () => {
            row.delFlag = true
            await updateActivityType(row)
            proxy.$baseMessage(`删除成功`, 'success', 'vab-hey-message-success')
            queryData()
          })
        } catch (e) {}
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        queryData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        queryData()
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        save,
        addType,
        delHostInfo,
        handleSizeChange,
        handleCurrentChange,
      }
    },
  })
</script>

<style lang="scss">
  .userInfoDrawer {
    .el-transfer-panel {
      width: 250px;
    }
    .hideLabel {
      .el-descriptions__label {
        display: none;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
  .margin-top {
    margin-top: 20px;
  }
</style>
